<div class="liste-ordonnances-container">
    <div class="liste-ordonnances-title-container">
        <p class="text-danger" *ngIf="!isPharmacieActive">
            Vous n'avez pas souscris au service d'envoi et réception d'ordonnance. Pour autoriser ce service, activez le paramètre via l'onglet "Mon Compte"
        </p>
        <h3 *ngIf="ordonnances.length > 0 ">Liste des ordonnances</h3>
        <h3 *ngIf="!(ordonnances.length > 0) && ordonnanceService.isDataLoaded">Aucune ordonnance</h3>
    </div>
    <div *ngIf="ordonnances.length > 0 " class="liste-ordonnances-table-container">
        <ng-container *ngIf="ordonnanceService.isDataLoaded; else loading">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col" *ngFor = "let column of headers" >
                            {{column}}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr class="ordonnance"
                        [ngClass]="{'ordonnance-atraiter': ordonnance.etat === enumEtats.ATRAITER,
                                    'ordonnance-traitee': ordonnance.etat === enumEtats.TRAITEE,
                                    'ordonnance-rejetee': ordonnance.etat === enumEtats.REJETEE,
                                    'ordonnance-encours': ordonnance.etat === enumEtats.ENCOURS}"
                        *ngFor = "let ordonnance of ordonnances">
                        <td scope="row" class="state-cell">{{ordonnance.etat}}</td>
                        <td>
                          <div class="ordonnance-img-container" *ngFor="let image of ordonnance.images; index as i">
                            <img *ngIf="ordonnance.extensions[i] != 'pdf'" ngbTooltip="image" alt="ordonnance-file" (click)="afficherImageModal(ordonnance.images, ordonnance.extensions, i)" [src]="'data:image/jpg;base64,'+image"/>
                            <div *ngIf="ordonnance.extensions[i] === 'pdf'" class="ordonnance-pdf-icon " ngbTooltip="pdf" (click)="downloadPDF(ordonnance)" >
                              <i class="fas fa-file-pdf fa-2x"></i>
                            </div>

                          </div>
                        </td>
                        <td><span class="patient" (click)="afficherModalInformationsPatient(ordonnance)">{{ordonnance.nom}} {{ordonnance.prenom}}</span></td>
                        <td>
                            <div class="row icons-section">
                              <div  class="ordonnance-icon visualize-ordonnance-icon" ngbTooltip="Visualiser l'ordonnance" placement="top" (click)="afficherImageModal(ordonnance.images, ordonnance.extensions, 0)">
                                <i class="fas fa-eye"></i>
                              </div>
                              <div class="ordonnance-icon visualize-ordonnance-icon" ngbTooltip="Télécharger l'ordonnance" placement="top" (click)="downloadPDF(ordonnance)">
                                <i class="fas fa-download"></i>
                              </div>

                              <div class="ordonnance-icon print-ordonnance-icon" ngbTooltip="Imprimer l'ordonnance" placement="top" (click)="printOrdonnance(ordonnance.images[0])">
                                    <i class="fas fa-print"></i>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="row icons-section" *ngIf="isOrdonnanceActionAuthorize(ordonnance); else message">
                                <div *ngIf="ordonnance.etat !== enumEtats.ENCOURS" class="message-icon question-message-icon" ngbTooltip="Demande d'information" placement="top" (click)="afficherOrdonnanceQuestionModal(ordonnance)">
                                    <i class="far fa-question-circle"></i>
                                </div>
                                <div class="message-icon check-message-icon" ngbTooltip="Ordonnance traitée" placement="top" (click)="afficherOrdonnanceTraiteeModal(ordonnance)">
                                    <i class="text-success fas fa-check"></i>
                                </div>
                                <div class="message-icon times-message-icon" ngbTooltip="Traitement impossible" placement="top" (click)="afficherOrdonnanceRejeteeModal(ordonnance)">
                                    <i class="text-danger fas fa-times"></i>
                                </div>
                            </div>
                            <ng-template #message>
                                <div class="row message-section">
                                    <span>{{getMessageState(ordonnance)}}</span>
                                </div>
                            </ng-template>
                        </td>
                        <td>{{ordonnance.date | date:'dd/MM/yyyy'}} à {{ordonnance.date | date:'HH:mm'}}</td>
                        <td>
                          <div *ngIf="ordonnance.srcSend == 'mobile'">
                            App mobile
                        </div>
                          <div *ngIf="ordonnance.srcSend == 'clickandcollect'">
                            Click & Collect
                          </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </ng-container>
        <ng-template #loading>
            <div class="loading-container">
                <p>Chargement des ordonnances ...</p>
            </div>
        </ng-template>
    </div>

    <div>
       <ul *ngIf="ordonnances.length > 0 " class="pagination">
            <li><button class="btn btn-secondary btn-sm pagination-button" (click)="goToFirstPage()"><<</button></li>
            <li><button class="btn btn-secondary btn-sm pagination-button" (click)="goToBeforePage()"><</button></li>
            <ng-container *ngFor="let page of getPaginationArray(2)">
                <li><button
                class="btn btn-secondary btn-sm pagination-button"
                    *ngIf="page >= 1 && page <= nbPages"
                    [ngClass]="{'current-page': page == getCurrentPage()}"
                    (click)="goToPageNumber(page)">
                    {{page}}
                </button></li>
            </ng-container>
            <li><button class="btn btn-secondary btn-sm pagination-button" (click)="goToAfterPage()">></button></li>
            <li><button class="btn btn-secondary btn-sm pagination-button" (click)="goToLastPage()">>></button></li>
        </ul>
      </div>
</div>

 <app-patient-information-modal
    *ngIf="afficherPatientInformations"
    [ordonnance]="selectedOrdonnance"
    (modalPatientInformations)="changeAfficherPatientInformation($event)">
 </app-patient-information-modal>

<app-realsize-image-modal
  *ngIf="afficherImage"
  [images]="images"
  [extensions]="extensions"
  [index]="index"
  (modalStateChanged)="setImageModalState($event)">
</app-realsize-image-modal>

<app-ordonnance-state-modal
    *ngIf="afficherOrdonnanceEtat"
    [ordonnance]="selectedOrdonnance"
    [etat]="etat"
    (modalOrdonnanceState)="setOrdonnanceStateModalState($event)"
    (needToRefreshList)="refreshOrdonnancesList()">
</app-ordonnance-state-modal>
